import { render } from "./CategorySalesReport.vue?vue&type=template&id=aebad280&scoped=true"
import script from "./CategorySalesReport.vue?vue&type=script&lang=js"
export * from "./CategorySalesReport.vue?vue&type=script&lang=js"

import "./CategorySalesReport.vue?vue&type=style&index=0&id=aebad280&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebad280"]])

export default __exports__